<template>
  <v-form v-model="valid" @submit.prevent="upload">
    <v-stepper v-model="e6" vertical>
      <v-stepper-step :complete="e6 > 1" step="1">
        Your Information
        <small>Fill in the information below to get started</small>
      </v-stepper-step>

      <v-stepper-content step="1">
        <v-card>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="contact.name"
                :counter="30"
                :rules="nameRules"
                label="Name"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="contact.email"
                :rules="emailRules"
                label="E-mail"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="contact.age"
                :counter="2"
                :rules="ageRules"
                label="Age"
                required
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="contact.state"
                :counter="30"
                :rules="stateRules"
                label="State"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="contact.city"
                :counter="30"
                :rules="cityRules"
                label="City"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="contact.address"
                :counter="30"
                :rules="addressRules"
                label="Address"
                required
              ></v-text-field>
            </v-col>
          </v-row>

            <v-btn
              color="#1E88E5"
              class="text-white"
              type="submit"
              small
              :disabled="submitted && !valid"
              @click="e6 = 1"
              >Create User</v-btn
            >
            <v-btn color="#FF9800" class="text-white" small @click="e6 = 1"
              >Back</v-btn
            >

        </v-card>
      </v-stepper-content>

    </v-stepper>
  </v-form>
</template>

<script>
export default {
  data() {
    return {
      items: [
        "would like business software",
        "would like an assessment of existing software systems",
        "would like to expand business capabilities",
        "would like to optimize business capabilites"
      ],
      e6: 1,
      valid: true,
      submitted: true,

      // user information rules for validation
      nameRules: [
        v => !!v || "Name is required",
        v => (v && v.length <= 30) || "Name must be less than 30 characters"
      ],

      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],

      ageRules: [
        v => !!v || "Age is required",
        v => (v && v.length == 2) || "Age must be a valid"
      ],

      stateRules: [
        v => !!v || "State is required",
        v => (v && v.length <= 30) || "State must be less than 30 characters"
      ],

      cityRules: [
        v => !!v || "City is required",
        v => (v && v.length <= 30) || "State must be less than 30 characters"
      ],

      addressRules: [
        v => !!v || "Address is required",
        v => (v && v.length <= 30) || "Address must be less than 30 characters"
      ],

      // user Business rules for validation

      bizRules: [
        v => !!v || "Business name is required",
        v =>
          (v && v.length <= 30) ||
          "Business name must be less than 30 characters"
      ],

      contactRules: [
        v => !!v || "Point of contact is required",
        v =>
          (v && v.length <= 15) ||
          "Point of contact must be less than 15 characters"
      ],

      pocRules: [
        v => !!v || "Point of contact title is required",
        v =>
          (v && v.length <= 15) ||
          "Point of contact title must be less than 15 characters"
      ],

      bizAddRules: [
        v => !!v || "Business address is required",
        v =>
          (v && v.length <= 30) ||
          "Business address must be less than 30 characters"
      ],

      industryRules: [
        v => !!v || "Industry is required",
        v =>
          (v && v.length <= 30) || "Industry  must be less than 30 characters"
      ],

      contact: {}
    };
  },

  methods: {
    upload() {
      window.axios.post("api/create/user", {
        ...this.contact
      }).then(() => {
        this.$swal('Thank You!', 'User successfully created');
         this.contact = "",
         this.valid = true,
         this.submitted = true;
         this.$emit('evento');
      });
    }
  }
};
</script>
